import PropTypes from 'prop-types'
import { Component } from 'react'

import { Button } from './Components'
import { DEFAULT_NODE, hasBlock, hasLinks, hasMark, unwrapLink, wrapLink } from './utils'

export default class ToolbarButton extends Component<any, any> {
  static propTypes = {
    value: PropTypes.object.isRequired,
    editor: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element])
  }

  static defaultProps = {
    children: null
  }

  onClickMark = (event: any, type: any) => {
    event.preventDefault()
    this.props.editor.toggleMark(type)
  }

  onClickBlock = (event: any, type: any) => {
    event.preventDefault()

    const { editor } = this.props
    const { value } = editor
    const { document } = value

    // Handle everything but list buttons.
    if (type !== 'bulleted-list' && type !== 'numbered-list') {
      const isActive = hasBlock(value, type)
      const isList = hasBlock(value, 'list-item')

      if (isList) {
        editor
          .setBlocks(isActive ? DEFAULT_NODE : type)
          .unwrapBlock('bulleted-list')
          .unwrapBlock('numbered-list')
      } else {
        editor.setBlocks(isActive ? DEFAULT_NODE : type)
      }
    } else {
      // Handle the extra wrapping required for list buttons.
      const isList = hasBlock(value, 'list-item')
      const isType = value.blocks.some((block: any) => {
        return !!document.getClosest(block.key, (parent: any) => parent.type === type)
      })

      if (isList && isType) {
        editor.setBlocks(DEFAULT_NODE).unwrapBlock('bulleted-list').unwrapBlock('numbered-list')
      } else if (isList) {
        editor.unwrapBlock(type === 'bulleted-list' ? 'numbered-list' : 'bulleted-list').wrapBlock(type)
      } else {
        editor.setBlocks('list-item').wrapBlock(type)
      }
    }
  }

  isLinkButtonDisabled = (value: any) => {
    return !(value.selection.isExpanded || hasLinks(value))
  }

  onClickLink = (event: any) => {
    event.preventDefault()

    const { editor } = this.props
    const { value } = editor

    if (hasLinks(value)) {
      editor.command(unwrapLink)
    } else if (value.selection.isExpanded) {
      editor.command(wrapLink, '')
    }
  }

  renderMarkButton = (type: any, children: any) => {
    const { value } = this.props
    const isActive = hasMark(value, type)

    return (
      <Button active={isActive} onMouseDown={(event: any) => this.onClickMark(event, type)}>
        {children}
      </Button>
    )
  }

  renderLinkButton = (type: any, children: any) => {
    const { value } = this.props
    const isActive = hasLinks(value)
    const isDisabled = this.isLinkButtonDisabled(value)

    return (
      <Button active={isActive} onMouseDown={(event: any) => this.onClickLink(event)} disabled={isDisabled}>
        {children}
      </Button>
    )
  }

  renderBlockButton = (type: any, children: any) => {
    const { value } = this.props
    let isActive = hasBlock(value, type)

    if (['numbered-list', 'bulleted-list'].includes(type)) {
      const { document, blocks } = value

      if (blocks.size > 0) {
        const parent = document.getParent(blocks.first().key)
        isActive = hasBlock(value, 'list-item') && parent && parent.type === type
      }
    }

    return (
      <Button active={isActive} onMouseDown={(event: any) => this.onClickBlock(event, type)}>
        {children}
      </Button>
    )
  }

  render() {
    const { type, children } = this.props

    switch (type) {
      case 'underline':
      case 'bold':
      case 'italic': {
        return this.renderMarkButton(type, children)
      }
      case 'numbered-list':
      case 'bulleted-list': {
        return this.renderBlockButton(type, children)
      }
      case 'link': {
        return this.renderLinkButton(type, children)
      }
      default: {
        return null
      }
    }
  }
}
